import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, ArrowRight, CalendarDays } from 'lucide-react';
import useReveal from '../hooks/useReveal';
import { images } from '../mock/mock';
import { useContent } from '../context/ContentContext';

export default function Classes() {
  useReveal([]);
  const { content, img } = useContent();
  const events = content.events || [];

  if (events.length > 0) {
    return (
      <div className="bg-[#E9EBED]">
        <div className="pt-28" />
        <section className="py-16 sm:py-20">
          <div className="max-w-5xl mx-auto px-5 sm:px-8">
            <div className="reveal text-center max-w-2xl mx-auto">
              <p className="text-[#2C3A28] text-sm font-semibold uppercase tracking-[0.28em]">
                Classes &amp; Events
              </p>
              <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold uppercase text-[#2C3A28]">
                What's on
              </h1>
              <p className="mt-4 text-[#2C3A28]/70 text-lg">
                Hands-on classes and special events at our St Kilda café.
              </p>
            </div>

            <div className="mt-12 grid sm:grid-cols-2 gap-6" data-testid="events-list">
              {events.map((ev, i) => (
                <div key={ev.id || i} className="reveal rounded-3xl bg-white p-7" data-testid={`event-card-${i}`}>
                  {ev.date && (
                    <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-[#2C3A28]/70">
                      <CalendarDays size={16} /> {ev.date}
                    </span>
                  )}
                  <h3 className="mt-3 font-display text-2xl font-semibold text-[#2C3A28]">{ev.title}</h3>
                  {ev.description && <p className="mt-3 text-[#2C3A28] leading-relaxed">{ev.description}</p>}
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="bg-[#E9EBED]">
      <section className="relative min-h-screen flex items-center justify-center text-center overflow-hidden bg-[#2C3A28] text-[#E9EBED]">
        <img
          src={img('cafeInterior', images.cafeInterior)}
          alt="Inside the Al Naturale cafe"
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#2C3A28]/70 via-[#2C3A28]/85 to-[#2C3A28]" />

        <div className="relative max-w-2xl mx-auto px-5 sm:px-8 py-32" data-testid="classes-coming-soon">
          <span className="inline-flex w-16 h-16 rounded-full bg-[#2C3A28] text-white items-center justify-center">
            <GraduationCap size={30} />
          </span>

          <p className="mt-8 text-[#2C3A28] text-sm font-semibold uppercase tracking-[0.28em]">
            Classes &amp; Events
          </p>
          <h1 className="mt-4 text-6xl sm:text-7xl leading-[1.05] text-[#E9E5D8]" style={{ fontFamily: "'Pinyon Script', cursive" }}>
            Coming soon
          </h1>
          <p className="mt-6 font-display text-[#E9EBED]/80 text-lg sm:text-xl leading-relaxed">
            We're crafting something special, hands-on classes to share the art of
            small-batch nut milks and natural food. Watch this space.
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/products"
              data-testid="classes-shop-link"
              className="group inline-flex items-center gap-2 rounded-full bg-[#2C3A28] text-white px-7 py-4 font-semibold hover:bg-[#1f2a1c] transition-all hover:-translate-y-0.5"
            >
              Shop the range
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>
            <Link
              to="/cafe"
              data-testid="classes-cafe-link"
              className="inline-flex items-center gap-2 rounded-full border border-[#E9EBED]/30 text-[#E9EBED] px-7 py-4 font-semibold hover:bg-[#E9EBED]/10 transition-colors"
            >
              Visit the cafe
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
